/*
 * Potzillas · Wishlist (Oblíbené) — lightweight, bez appky.
 * Ukládá handly produktů do localStorage. Srdíčko toggluje, hlavička má
 * počítadlo, stránka /pages/oblibene vykreslí uložené produkty (přes
 * Section Rendering API → správná cena/měna podle marketu).
 * Omezení: per prohlížeč (nesynchronizuje se mezi zařízeními).
 */
(function () {
  if (window.__pzWishlist) return;
  window.__pzWishlist = true;

  var KEY = 'pz:wishlist';

  var HEART =
    '<span class="pz-wishlist-btn__icon" aria-hidden="true">' +
    '<svg viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M12 20.5l-1.45-1.32C5.4 14.36 2 11.28 2 7.5 2 4.42 4.42 2 7.5 2c1.74 0 3.41.81 4.5 2.09C13.09 2.81 14.76 2 16.5 2 19.58 2 22 4.42 22 7.5c0 3.78-3.4 6.86-8.55 11.68L12 20.5z" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/>' +
    '</svg></span>';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }
  function toggle(h) {
    var list = read();
    var i = list.indexOf(h);
    if (i === -1) list.push(h);
    else list.splice(i, 1);
    write(list);
    sync();
    return i === -1;
  }

  // Sjednoť stav srdíček + počítadlo v hlavičce
  function sync() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-wishlist-handle')) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = on ? 'Odebrat z oblíbených' : 'Přidat do oblíbených';
      btn.setAttribute('aria-label', lbl);
      btn.setAttribute('title', lbl);
      var textEl = btn.querySelector('.pz-wishlist-btn__label');
      if (textEl) textEl.textContent = on ? 'Uloženo v oblíbených' : 'Uložit do oblíbených';
    });
    // Hlavička: srdíčko vyplněné, když je aspoň 1 oblíbený (bez čísla)
    var hasAny = list.length > 0;
    document.querySelectorAll('.header__icon--wishlist').forEach(function (el) {
      el.classList.toggle('is-active', hasAny);
    });
  }

  // Klik na srdíčko
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var h = btn.getAttribute('data-wishlist-handle');
    if (!h) return;
    var added = toggle(h);
    // Na stránce Oblíbené po odebrání rovnou odeber kartu
    if (!added) {
      var grid = document.querySelector('[data-wishlist-grid]');
      if (grid) {
        var item = btn.closest('[data-wishlist-item]');
        if (item) {
          item.remove();
          refreshEmptyState();
        }
      }
    }
  });

  // Detail produktu: srdíčko vpravo nahoře přímo na 1. fotce (jako v kolekcích).
  // Vkládáme ho do .product-media-container první fotky — ten je dle Dawn
  // position:relative (.product__media-item > *) a má velikost přesně podle
  // obrázku, takže srdíčko sedí na fotce a scrolluje s ní (ne s celým sloupcem).
  function injectPDP() {
    if (window.location.pathname.indexOf('/products/') === -1) return;
    if (document.querySelector('[data-wishlist-pdp]')) return;
    var parts = window.location.pathname.split('/products/')[1];
    if (!parts) return;
    var handle = parts.split('/')[0].split('?')[0];
    if (!handle) return;
    var item =
      document.querySelector('.product__media-item.is-active') ||
      document.querySelector('.product__media-item');
    var box = item ? item.querySelector('.product-media-container') : null;
    var anchor = box || document.querySelector('.product__title');
    if (!anchor) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = box
      ? 'pz-wishlist-btn pz-wishlist-btn--pdp-media'
      : 'pz-wishlist-btn pz-wishlist-btn--qty';
    btn.setAttribute('data-wishlist-toggle', '');
    btn.setAttribute('data-wishlist-handle', handle);
    btn.setAttribute('data-wishlist-pdp', '');
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML = HEART;
    if (box) {
      box.classList.add('pz-has-wishlist-media');
      // Vlastní stacking context (z-index 1, pod sticky hlavičkou 3–4) nastavíme
      // i inline — funguje, i kdyby CSS soubor do theme nedojel (Shopify sync).
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      if (!box.style.zIndex) box.style.zIndex = '1';
      box.appendChild(btn);
    } else {
      anchor.insertAdjacentElement('afterend', btn);
    }
  }

  // E-mail tlačítko vyrobíme přes JS (sekce se nemusí nasyncovat) — vloží se
  // pod mřížku, pokud tam ještě není.
  function ensureShareButton() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    if (document.querySelector('[data-wishlist-actions]')) return;
    var actions = document.createElement('div');
    actions.className = 'pz-wishlist-actions';
    actions.setAttribute('data-wishlist-actions', '');
    actions.innerHTML =
      '<button type="button" class="pz-wishlist-share" data-wishlist-share>Poslat e-mailem<span aria-hidden="true"> →</span></button>';
    grid.insertAdjacentElement('afterend', actions);
  }

  // Stránka Oblíbené
  function refreshEmptyState() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var hasItems = !!grid.querySelector('[data-wishlist-item]');
    grid.hidden = !hasItems;
    if (empty) empty.hidden = hasItems;
    var actions = document.querySelector('[data-wishlist-actions]');
    if (actions) actions.hidden = !hasItems;
  }

  // Poslat wishlist e-mailem (mailto — otevře poštovního klienta)
  function shareByEmail() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var lines = [];
    grid.querySelectorAll('[data-wishlist-item]').forEach(function (item) {
      var link = item.querySelector('.card__heading a') || item.querySelector('a[href*="/products/"]');
      if (!link) return;
      var title = (link.textContent || '').replace(/\s+/g, ' ').trim();
      var href = link.getAttribute('href') || '';
      if (href && href.indexOf('http') !== 0) href = window.location.origin + href;
      if (title) lines.push('• ' + title + (href ? '\n  ' + href : ''));
    });
    if (!lines.length) return;
    var subject = 'Můj wishlist – Potzillas';
    var body = 'Ahoj,\n\nposílám svůj výběr z Potzillas:\n\n' + lines.join('\n\n') + '\n\nPotzillas.cz';
    window.location.href = 'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wishlist-share]')) {
      e.preventDefault();
      shareByEmail();
    }
  });

  function renderPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    ensureShareButton();
    var list = read();
    grid.innerHTML = '';
    if (!list.length) {
      refreshEmptyState();
      return;
    }
    var sectionId = grid.getAttribute('data-wishlist-section') || 'potzillas-wishlist-card';
    Promise.all(
      list.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '?section_id=' + sectionId)
          .then(function (r) {
            return r.ok ? r.text() : '';
          })
          .catch(function () {
            return '';
          });
      })
    ).then(function (htmls) {
      htmls.forEach(function (html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var card = tmp.querySelector('.card-wrapper');
        if (!card) return;
        var li = document.createElement('li');
        li.className = 'grid__item';
        li.setAttribute('data-wishlist-item', '');
        li.appendChild(card);
        grid.appendChild(li);
      });
      refreshEmptyState();
      sync();
    });
  }

  function init() {
    injectPDP();
    sync();
    renderPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Sync mezi taby
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) {
      sync();
      renderPage();
    }
  });

  // Editor / re-render sekcí
  document.addEventListener('shopify:section:load', function () {
    injectPDP();
    sync();
    renderPage();
  });
})();
